import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for SoftAvatar
import SoftAvatarRoot from "src/components/SoftAvatar/SoftAvatarRoot";

const SoftAvatar = forwardRef(
  (
    { bgColor = "transparent", size = "md", shadow = "none", src, ...rest },
    ref
  ) => (
    <SoftAvatarRoot
      ref={ref}
      ownerState={{
        shadow,
        bgColor,
        size,
      }}
      src={src}
      {...rest}
    />
  )
);

// Typechecking props for the SoftAvatar
SoftAvatar.propTypes = {
  bgColor: PropTypes.oneOf([
    "transparent",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl"]),
  shadow: PropTypes.oneOf([
    "none",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "inset",
  ]),
  src: PropTypes.any,
};

export default SoftAvatar;
